import { Loader } from 'semantic-ui-react';

const FBCLoader = () => {
  return <Loader active inline="centered" />;
};

export default FBCLoader;
